import React, {useState, useEffect} from "react";
import style from "./block.module.scss";
import logo from "./logoSetC2.png";

export default function Header({social, menu}) {

    // State open menu for mobile
    const [open, setOpen] = useState(false);
    useEffect(() => {
        if(open) {
            document.body.style.overflowY = "hidden";
            return () => {
                document.body.style.overflowY = null;
            }
        }
    }, [open]);

    return <div className={style.block}>
            <div className={style.header}>
                <div className={style.logo}>
                    <a href="/"><img src={logo} alt="Sens et Croissance" /></a>
                </div>
                <div className={open ? style.menuOpen : style.menu}>
                    <div className={style.menuMobile} onClick={() => setOpen(!open)}/>
                    <div className={style.wp} dangerouslySetInnerHTML={{__html: menu}}/>
                </div>
            </div>
        </div>;
}
